module.exports = __webpack_public_path__ + "img/cwgl.fb23930b.png";